import React, { use, useEffect } from 'react';
import './home.css';
import '../pages/Branding.js';
import '../pages/Programs.js';
import Recommendations from './Recommendation.js';
import ContactUs from '../components/ContactUs.js';
import PopupOnce from './PopupOnce.js';

const Home = () => {
  return (
    <>
    <PopupOnce></PopupOnce>
    <div className="home-container">
      <div className="home-promo">
        <div className="home-root">
          <h2 className='home-title'>כיף להיכנס לכאן, הא?<br/>גם אנחנו חושבות כך</h2>
          <p>מחכות לך כאן התוכניות הכי טובות שיכולת לאחל לעצמך,</p>
          <p>לכל מפגש ומסיבה</p>
          <p>לכיתה, לחברות, למשפחה, למשפחה מהצד השני...</p>
          <p>למתי שצריך, או למתי שמתחשק :)</p>

          <h4> תני הצצה! התוכניות שלנו ממש מחכות שתראי אותן</h4>
        </div>
      </div>

      <div className="logo-card">
        <img
          src={process.env.PUBLIC_URL + '/לוגו-012.png'}
          alt="לוגו"
          className="home-logo"
        />
      </div>
    </div>
    <Recommendations></Recommendations>
    <ContactUs></ContactUs>
          </>

  );
};

export default Home;
